import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/app/src/components/ui/sidebar.tsx");
